"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Memory = void 0;
const mem_reader_1 = require("./mem-reader");
class Memory extends mem_reader_1.MemReader {
    constructor() {
        super([]);
        this.onChange = null;
    }
    set(index, byte) {
        if (byte < 0 || byte > 255) {
            throw new Error('Wrong byte value ' + byte);
        }
        this.resize(index + 1);
        this.mem[index] = byte;
        this.onChange?.();
    }
    setUint256(index, value) {
        this.resize(index + 32);
        const bytes = value.toByteArray();
        for (let i = 0; i < 32; i++) {
            this.mem[index + i] = bytes[i];
        }
        this.onChange?.();
    }
    resize(_toSize) {
        const mod = _toSize % 32;
        const toSize = mod ? _toSize - mod + 32 : _toSize;
        if (this.mem.length >= toSize) {
            return;
        }
        do {
            this.mem.push(0);
        } while (this.mem.length < toSize);
        this.onChange?.();
    }
    get(offset) {
        this.resize(offset + 32);
        return super.get(offset);
    }
    getNoResize(offset) {
        if (offset >= this.size) {
            return null;
        }
        return super.get(offset);
    }
    dump() {
        return [...this.mem];
    }
}
exports.Memory = Memory;
//# sourceMappingURL=memory.js.map